"use client";
import { PropsWithChildren } from "react";
import { useMediaQuery } from "@mui/material";
interface BackGroundImageProps extends PropsWithChildren {
	desktopUrl?: string;
	mobileUrl?: string;
	className?: string;
}
const BackGroundImage: React.FC<BackGroundImageProps> = ({
	children,
	desktopUrl,
	mobileUrl,
	className,
}) => {
	const isMobile = useMediaQuery("(max-width:768px)");
	const bgUrl = isMobile ? desktopUrl : mobileUrl;

	return (
		<div
			style={{
				backgroundImage: `url(${bgUrl})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
			}}
			className={className}
		>
			{children}
		</div>
	);
};
export default BackGroundImage;
